<template>
  <Modal
      :withClose="true"
      myMaxWidth="640px"
      v-model="show"
      @input="close"
  >
    <template>
      <v-container fluid pa-0>
        <v-layout px-4 py-3 row wrap>
          <v-flex>
            <InputText
              ref="nameInput"
              type="text"
              textLabel="Nome do Vídeo"
              v-model="video.name"
              place-holder="Nome do vídeo"
            />
            <InputText
              ref="linkInput"
              v-model="video.link"
              type="text"
              place-holder="Insira o link do video"
              textLabel="Vídeo - Youtube"
              helpLabel="Ex: https://www.youtube.com/embed/TJ5xnIEOFvw"
            />
          </v-flex>
          <div class="d-flex xs4 align-end px-3">
            <v-btn
              flat
              round
              color="white"
              class="btn-primary px-5 ml-auto mr-0"
              large
              @click="save()"
            >Salvar</v-btn>
          </div>
        </v-layout>
      </v-container>
    </template>
  </Modal>
</template>

<script type="plain/text">
import Modal from "@/components/Modal.vue";
import CommonHelper from "@/scripts/helpers/common.helper";
import Video from "@/scripts/models/video.model";
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: false,
      video: new Video()
    };
  },
  methods: {
    open() {
      this.video = new Video();
      this.show = true;
    },
    close() {
      this.$emit("close");
      this.video = new Video();
      this.show = false;
    },
    save() {
      let videoHash = CommonHelper.validateYoutubeLink(this.video.link);
      if (videoHash && videoHash.length == 11) {
        this.$emit("save", this.video);
        this.close();  
      } else {
        CommonHelper.swal("Link inválido");
      }
    }
  }
};
</script>
